// React, Next
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import { GlobalContext } from 'context/GlobalContextProvider'

// Style
import themeColors from 'assets/theme/colors'
import breakpoints from 'assets/theme/breakpoints'
import { getFontBodySmall } from '@/assets/theme/fonts'

export default function TopicsSection() {
  const { t } = useTranslation('servicesOtAwarenessTraining')
  const { screenDimensions } = useContext(GlobalContext)

  const w = screenDimensions.width

  const topics = [
    {
      n: '01',
      title: t('topics.items.01.title'),
      text: t('topics.items.01.text')
    },
    {
      n: '02',
      title: t('topics.items.02.title'),
      text: t('topics.items.02.text')
    },
    {
      n: '03',
      title: t('topics.items.03.title'),
      text: t('topics.items.03.text')
    },
    {
      n: '04',
      title: t('topics.items.04.title'),
      text: t('topics.items.04.text')
    },
    {
      n: '05',
      title: t('topics.items.05.title'),
      text: t('topics.items.05.text')
    },
    {
      n: '06',
      title: t('topics.items.06.title'),
      text: t('topics.items.06.text')
    },
    {
      n: '07',
      title: t('topics.items.07.title'),
      text: t('topics.items.07.text')
    },
    {
      n: '08',
      title: t('topics.items.08.title'),
      text: t('topics.items.08.text')
    },
    {
      n: '09',
      title: t('topics.items.09.title'),
      text: t('topics.items.09.text')
    },
    {
      n: '10',
      title: t('topics.items.10.title'),
      text: t('topics.items.10.text')
    }
  ]

  const getGrid = () => {
    if (w > breakpoints.desktopMid) return 'repeat(3, 1fr)'
    if (w > breakpoints.desktopToMobile) return 'repeat(2, 1fr)'
    if (w > breakpoints.mobileMid) return 'repeat(2, 1fr)'
    return 'repeat(1, 1fr)'
  }

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader eyebrow={t('topics.eyebrow')} title={t('topics.title')} />

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: getGrid(),
          gap: '1.5rem',
          alignItems: 'stretch'
        }}
      >
        {topics.map(topic => (
          <Box
            key={topic.n}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              background: themeColors.kroemtech.background,
              border: `1px solid ${themeColors.gray.lighter}`,
              borderRadius: '10px',
              padding: '1.6rem',
              boxSizing: 'border-box'
            }}
          >
            <Typography
              component="p"
              sx={{
                fontSize: '0.95rem',
                fontWeight: 700,
                color: themeColors.success.main,
                marginBottom: '0.6rem'
              }}
            >
              {topic.n}
            </Typography>

            <Typography
              variant="h3"
              component="h3"
              sx={{
                fontSize: '1.02rem',
                fontWeight: 700,
                lineHeight: 1.3,
                color: themeColors.kroemtech.dunkelblau,
                marginBottom: '0.7rem'
              }}
            >
              {topic.title}
            </Typography>

            <Typography
              sx={{
                fontSize: getFontBodySmall(),
                lineHeight: 1.65,
                color: themeColors.gray.defaultText
              }}
            >
              {topic.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
